import React, {useContext } from "react";
import PropertySizeSelect from "./PropertySizeSelect";
import AutoComplete from "../common/AutoComplete";
import InfoImgIcon from "../../assets/images/icons/info.png";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import MovePlannerContext from "../../context/move_planner/movePlanner";
import { Controller } from "react-hook-form";
import DatePicker from "react-datepicker";
import { useSelector } from "react-redux";
// import { createMuiTheme } from "@material-ui/core";
// import { ThemeProvider } from "@material-ui/styles";
// import { makeStyles } from "@material-ui/core/styles";
// import { DateTimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
// import MomentUtils from "@date-io/moment";
// const useStyles = makeStyles({
//   input: {
//     border: "none",
//     padding: "2%",
//     paddingLeft: 0,
//     color: "#000",
//     fontWeight: 600,
//     fontSize: "0.875rem",
//     width: "100%",
//     fontFamily: "Montserrat",
//   },
// });

function BetweenCityQuote(props) {
  const context = useContext(MovePlannerContext);
  const moveInfoState = useSelector((state) => state.moveInfo);

  const fromPlace = moveInfoState.interCityMovingFrom;
  const toPlace = moveInfoState.interCityMovingTo;
  const propertySize = moveInfoState.interCityPropertySize;
  const movingOnDate = moveInfoState.interCityMovingOnDate;
  const isMoveDateFlexible = moveInfoState.interCityhasFlexibleDate;

  // const [selectedDate, handleDateChange] = useState(new Date());
  const { register, errors, control, setValue, getValues } =
    context.estimateForm.useMoveInfoForm;

  // const materialTheme = createMuiTheme({
  //   palette: {
  //     primary: {
  //       main: "#ee553b",
  //     },
  //   },
  // });
  // const classes = useStyles();

  const isFromAndToSame = () => {
    if (props.enabled === true) {
      // debugger;
      const from = getValues("from_area_between");
      const to = getValues("to_area_between");
      if (from === "" || to === "") {
        return true;
      }
      if (from === to) {
        return false;
      }
    }
    return true;
  };
  const isRequired = (value) => (props.enabled && value === "" ? false : true);

  const JSX = (
    <div
      className={`move-info between-city-move ${!props.enabled && "d-none"}`}
    >
      <div className="form-group">
        <label> I am shifting my </label>
        <PropertySizeSelect
          name="property_size_between_city"
          className="form-control"
          innerRef={register}
          defaultValue={propertySize}
        />
      </div>
      <div className="form-group">
        <label> Moving from </label>
        <label className="from_area_between-error error-text">
          {errors.from_area_between &&
            errors.from_area_between.type === "isRequired" &&
            "Required"}
          {errors.from_area_between &&
            errors.from_area_between.type === "isFromAndToSame" &&
            "From and To cannot be same"}
        </label>
        <AutoComplete
          name="from_area_between"
          placeholder="Select City"
          className="form-control"
          AutoCompleteID="fromAutocompletebetween"
          innerRef={register({
            validate: {
              isRequired: isRequired,
              isFromAndToSame: isFromAndToSame,
            },
          })}
          cityType={"Inter City"}
          defaultValue={fromPlace}
          changeHandler={(value) => {
            setValue("from_area_between", value);
          }}
        />
        {/* <AutoComplete
          name="from_area_within"
          placeholder="Locality"
          cityType={"within city"}
          className="form-control"
          innerRef={register({ required: true })}
          value={fromPlace}
          changeHandler={(value) => {
            setFromPlace(value);
          }}
          id="from_within"
          AutoCompleteID="fromAutocompletewithin"
        /> */}
      </div>
      <div className="form-group">
        <label> Moving to </label>
        <label className="to_area_between-error error-text">
          {errors.to_area_between &&
            errors.to_area_between.type === "isRequired" &&
            "Required"}
          {errors.to_area_between &&
            errors.to_area_between.type === "isFromAndToSame" &&
            "From and To cannot be same"}
        </label>
        <AutoComplete
          name="to_area_between"
          placeholder="Select City"
          className="form-control"
          id="to_between"
          AutoCompleteID="toAutocompletebetween"
          innerRef={register({
            validate: {
              isRequired: isRequired,
              isFromAndToSame: isFromAndToSame,
            },
          })}
          cityType={"inter city"}
          defaultValue={toPlace}
          changeHandler={(value) => {
            setValue("to_area_between", value);
          }}
        />
      </div>
      <div className="form-group border-0">
        <label> On </label>
        <label className="move_date_between-error error-text">
          {errors.move_date_between_city &&
            errors.move_date_between_city.type === "isRequired" &&
            "required"}
        </label>
        <div className="d-block">
          <Controller
            control={control}
            name="move_date_between_city"
            rules={{
              validate: {
                isRequired: isRequired,
                isFromAndToSame: isFromAndToSame,
              },
            }}
            defaultValue={movingOnDate}
            render={(props) => (
              <DatePicker
                className="form-control datetimepicker"
                showTimeSelect
                placeholderText="Moving date"
                onChange={(e) => props.onChange(e)}
                selected={props.value}
                dateFormat="dd/MM/yyyy h:mm aa"
                minDate={new Date()}
                timeFormat="HH:mm"
                timeIntervals={30}
                timeCaption="Time"
                showDisabledMonthNavigation
              />
            )}
          />
        </div>

        {/* <div className="">
          <Controller
            control={control}
            name="move_date_between_city"
            rules={{
              validate: {
                isRequired: isRequired,
              },
            }}
            defaultValue={movingOnDate === "" ? null : movingOnDate}
            render={(props) => (
              <ThemeProvider theme={materialTheme}>
                <MuiPickersUtilsProvider utils={MomentUtils}>
                  <DateTimePicker
                    value={props.value}
                    onChange={props.onChange}
                    emptyLabel={"Moving Date"}
                    format="DD-MM-YYYY HH:mm a"
                    minDate={new Date()}
                    InputProps={{
                      disableUnderline: true,
                      classes: {
                        input: classes.input,
                      },
                    }}
                  />
                </MuiPickersUtilsProvider>
              </ThemeProvider>
            )}
          />
          {/* <MuiPickersUtilsProvider utils={MomentUtils}>
            <DateTimePicker
              value={selectedDate}
              onChange={handleDateChange}
              format="DD-MM-YYYY HH:mm a"
              InputProps={{
                disableUnderline: true,
              }}
            />
          </MuiPickersUtilsProvider> */}
        {/* </div> */}
        <div
          className="custom-control custom-checkbox move-date-flexible-container"
          style={{ position: "static", marginBottom: "-1rem" }}
        >
          <input
            type="checkbox"
            className="custom-control-input"
            id="betweenDateFlexible"
            name="move_date_flexible_between"
            ref={register}
            defaultChecked={isMoveDateFlexible}
            // checked={
            //   isMoveDateFlexible === true
            //     ? "checked"
            //     : ""
            // }
          />
          <label className="custom-control-label" htmlFor="betweenDateFlexible">
            Is flexible?{" "}
          </label>
          <React.Fragment>
            <OverlayTrigger
              key={"top"}
              placement={"top"}
              overlay={
                <Tooltip id={`tooltip-${"top"}`}>
                  If you are unsure about your move date, check this and revisit
                  to alter before your actual move date.
                </Tooltip>
              }
            >
              <img src={InfoImgIcon} alt="i" />
              {/* <img src={Info} className="img-fluid mx-1" alt="" /> */}
            </OverlayTrigger>
          </React.Fragment>
        </div>
      </div>
      <div className="form-group border-0 submit-container">
        {moveInfoState.isMoveInfoFormSubmitting === false && (
          <input
            type="submit"
            className="btn btn-primary"
            value="Get Free Quote"
          />
        )}
        {moveInfoState.isMoveInfoFormSubmitting === true && (
          <button type="button" className="btn btn-primary">
            <div class="spinner-border" role="status">
              <span class="sr-only"></span>
              {"  "}
            </div>{" "}
            Submitting...
          </button>
        )}
      </div>
    </div>
  );
  return JSX;
}

export default BetweenCityQuote;
